import { render } from "./SplitDeliveries.vue?vue&type=template&id=3cefd233&scoped=true"
import script from "./SplitDeliveries.vue?vue&type=script&lang=js"
export * from "./SplitDeliveries.vue?vue&type=script&lang=js"

import "./SplitDeliveries.vue?vue&type=style&index=0&id=3cefd233&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cefd233"]])

export default __exports__